(() => {
  const backLink = document.querySelector('[data-sevenk-cart-back]');
  if (!backLink) return;

  backLink.addEventListener('click', (event) => {
    if (!document.referrer) return;

    try {
      const previousUrl = new URL(document.referrer);
      const isSameStore = previousUrl.origin === window.location.origin;
      const isDifferentPage = previousUrl.pathname !== window.location.pathname;

      if (isSameStore && isDifferentPage && window.history.length > 1) {
        event.preventDefault();
        window.history.back();
      }
    } catch (error) {
      // O href para a página inicial permanece como fallback seguro.
    }
  });
})();
